export default function usePermission(roles, permittedRoles) {
  return roles.map((role) => permittedRoles.includes(role)).some((role) => role);
}
